import { SaveButton } from "components/Buttons"
import React from "react"
import { withRouter, generatePath } from "react-router-dom"
import { Row, Col, Card, CardBody, Button, Table, CardFooter } from "reactstrap"

const CardWithoutData = ({ history, eventId, title, pathname }) => {
  return (
    <Col xl={4}>
      <Card>
        {/* style={{ minHeight: "415px" }} */}
        <CardBody className="pb-0">
          <Row>
            <Col>
              <h5>{title}</h5>
            </Col>
          </Row>
        </CardBody>
        <CardFooter style={{ background: "white" }} className="pt-0">
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color={"primary"}
                size="sm"
                content="View Reports"
                onClick={() => {
                  history.push({
                    pathname: pathname,
                    // state: { eventId: eventId },
                  })
                  // history.push(
                  //   generatePath(pathname, {
                  //     event_id: eventId,
                  //   })
                  // )
                }}
              />
            </Col>
          </Row>
        </CardFooter>
      </Card>
    </Col>
  )
}

export default withRouter(CardWithoutData)
